







































import {Vue, Component, Prop, Watch, Model} from 'vue-property-decorator';
import NodesTree from '@c/nodesTree/NodesTree.vue';
import {findNodeById} from '@/utils/nodeUtils';
import Loading from '@c/controls/Loading.vue';
import SimpleDialog from '@c/SimpleDialog.vue';
import nodeModule from '@/store/modules/entities/nodeModule';
import {NodeData} from '@/system/nodes/interfaces';

@Component({components: {NodesTree, Loading, SimpleDialog}})
export default class SelectNodeField extends Vue {
  // Возможность очистки поля
  @Prop({type: Boolean, default: false}) nullable!: boolean;

  // Заголовок поля
  @Prop() label!: string;

  // Показатель Только для чтения
  @Prop({type: Boolean, default: false}) readonly!: boolean;

  // Показатель disabled
  @Prop({type: Boolean, default: false}) disabled!: boolean;

  // Ключевое поле у элементов
  @Prop({required: false, default: 'id'})
  keyFieldName!: string;

  // Список элементов для выбора
  items: NodeData[] = [];

  selectedNodeModel: NodeData | null = null;

  // Модель диалогового окна
  dialog = false;

  // Показатели загрузки и наличия ошибок
  loading = false;
  error = false;
  presetLoading = false;

  @Watch('dialog')
  onDialog(value: boolean) {
    if (value && !this.items.length) {
      this.loading = true;
      this.loadTree();
    }
  }

  // Модель для выбранного элемента
  // Сейчас реализована возможность выбора одного элемента из списка
  @Model('changeNode') _selectedNodeId!: any;

  get selectedNodeId() {
    return this._selectedNodeId;
  }

  set selectedNodeId(newSelectedNodeId: any) {
    this.$emit('changeNode', newSelectedNodeId);
  }

  get selectedNode() {
    const stubNode = {name: ''};
    if (!this.selectedNodeId) return stubNode;
    const findNode = findNodeById(this.selectedNodeId, this.items);
    if (!findNode) return stubNode;
    return findNode;
  }

  get canSelect() {
    return this.selectedNodeModel != null;
  }

  // Загрузка дерева
  async loadTree() {
    try {
      this.loading = true;
      await nodeModule.fetchAll();
      this.items = [...nodeModule.all];
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
      this.presetLoading = false;
    }
  }

  created() {
    if (this.selectedNodeId) {
      this.presetLoading = true;
      this.loadTree();
    }
  }

  // Действия при выборе элемента
  onSelect() {
    this.selectedNodeId = this.selectedNodeModel?.id;
  }

  // Действия при очистке поля
  onClear() {
    this.selectedNodeId = null;
  }
}
